export function changeArrayItem<T>(source: T[], item: T, index: number) {
    return Object.assign([], source, { [index]: item });
}
